// @flow

import type {
   Player$CCColor, Player$CCFontFamily, Player$CCFontSize, Player$CCLocation
} from '../types/State';

import type { Player$Translation } from '../types/Translation';

export type CCOption<T: string> = {
   key?: $Keys<Player$Translation>,
   label?: string,
   value: T
}

export const DEFAULT_CC_TEXT_COLOR: Player$CCColor = '#FFF';
export const DEFAULT_CC_BG_COLOR: Player$CCColor = '#000';

export const CC_COLORS: CCOption<Player$CCColor>[] = [
   { key: 'red',      value: '#F44336' },
   { key: 'purple',   value: '#9C27B0' },
   { key: 'indigo',   value: '#3F51B5' },
   { key: 'blue',     value: '#2196F3' },
   { key: 'green',    value: '#4CAF50' },
   { key: 'yellow',   value: '#FFEB3B' },
   { key: 'orange',   value: '#FF9800' },
   { key: 'brown',    value: '#795548' },
   { key: 'grey',     value: '#9E9E9E' },
   { key: 'white',    value: '#FFF' },
   { key: 'black',    value: '#000' }
];

export const DEFAULT_CC_FONT_SIZE = '100%';

export const CC_FONT_SIZES: CCOption<Player$CCFontSize>[] = [
   { label: '75%',   value: '75%' },
   { label: '100%',  value: '100%' },
   { label: '125%',  value: '125%' },
   { label: '150%',  value: '150%' },
   { label: '200%',  value: '200%' }
];

export const DEFAULT_CC_FONT_FAMILY = 'Roboto, "Arial Unicode Ms", Arial, Helvetica, Verdana, sans-serif';

export const CC_FONT_FAMILIES: CCOption<Player$CCFontFamily>[] = [
   { key: 'monoserif',   value: '"Courier New", Courier, "Nimbus Mono L", "Cutive Mono", monospace' },
   { key: 'propserif',   value: '"Times New Roman", Times, Georgia, Cambria, "PT Serif Caption", serif' },
   { key: 'monosans',    value: '"Deja Vu Sans Mono", "Lucida Console", Monaco, Consolas, "PT Mono", monospace' },
   { key: 'propssans',   value: 'Roboto, "Arial Unicode Ms", Arial, Helvetica, Verdana, sans-serif' }
];

export const DEFAULT_CC_LOCATION = 'over';

export const CC_LOCATIONS: CCOption<Player$CCLocation>[] = [
   { key: 'cc-location-over',     value: 'over' },
   { key: 'cc-location-below',    value: 'below' }
];
